/**
 * SelectedPanel is a panel chip attached to the composer. It carries its own
 * entity/project/view scope so a persisted draft's chip is sent with the scope
 * it was attached under, never re-scoped to whatever route is active on send.
 */
export interface SelectedPanel {
  entityName: string;
  projectName: string;
  viewId?: string;
  viewType?: string;
  panelId: string;
  panelType: string;
  title?: string;
  queryPanelTableKey?: string;
  queryPanelTableKeyType?: string;
}

/**
 * panelKey is a panel chip's identity.
 *
 * NOTE: panel IDs aren't guaranteed stable between views of the same project,
 * so view is part of the key. Entity/project remain as a fallback namespace for
 * older prompt parts that do not carry view identity.
 */
export function panelKey(panel: SelectedPanel): string {
  return JSON.stringify([
    panel.entityName,
    panel.projectName,
    panel.viewId,
    panel.viewType,
    panel.panelId,
  ]);
}
